module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "components-container"
    }
  }, [_c('Draggablelist', {
    attrs: {
      "id": "contentEditor",
      "init-list1": _vm.list1,
      "init-list2": _vm.list2,
      "list1-title": "Top 3 customers",
      "list2-title": "Other customers",
      "displayedProperty": "name"
    },
    on: {
      "update:initList1": function($event) {
        _vm.list1 = $event
      },
      "update:initList2": function($event) {
        _vm.list2 = $event
      }
    }
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updateChange
    }
  }, [_vm._v("Update")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34aeb2a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Components/Draggablelist.vue
// module id = 756
// module chunks = 2